<p>empty-layout works!</p>
<router-outlet></router-outlet>